<template>
  <section class="order-section">
    <div class="register-container">
      <div class="row">
        <header class="full-header">
          <div class="top-header">
            <div class="container">
              <div class="row" style="justify-content: center">
                <div class="col-md-4">
                  <div class="topMessage">
                    <p>Decide. Commit. Succeed!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-wrap">
            <nav class="navbar topNavigation">
              <div class="container">
                <div class="navbar-header">
                  <button
                    type="button"
                    class="navbar-toggle"
                    data-toggle="collapse"
                    data-target="#myNavbar"
                  >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                  </button>
                  <a
                    class="navbar-brand logoWrap"
                    href="https://pro.dctrainings.com"
                    ><img src="./../../assets/images/logo.png" alt=""
                  /></a>
                </div>
                <div class="collapse navbar-collapse" id="myNavbar"></div>
              </div>
            </nav>
          </div>
          <div class="header-content inner">
            <div class="container">
              <div class="row" style="justify-content: center">
                <div
                  class="col-md-4 text-center contentbox contentbox-header box-header"
                >
                  <h3 class="heading">Membership</h3>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </header>
      </div>
    </div>
    <div id="content">
      <div>
        <div class="contentArea membership-page">
          <div class="container">
            <div class="contentWrap">
              <form
                method="post"
                @submit.prevent="createAccount"
                name="orderForm"
                id="orderForm"
              >
                <input type="hidden" name="upgrade" value="" />
                <div class="contentbox">
                  <input
                    id="previewMode"
                    name="previewMode"
                    type="hidden"
                    value="false"
                  />
                  <div class="row" style="justify-content: center">
                    <h3
                      class="text-center"
                      style="margin: 10px 0 30px; color: red; font-weight: bold"
                    >
                      Registration must be completed by the Primary Doctor of
                      Chiropractic (Practice Owner).
                    </h3>
                  </div>
                  <div
                    v-if="errShow"
                    class="notification"
                    style="
                      margin-bottom: 10px;
                      background: #e8b8b8;
                      padding: 20px;
                    "
                  >
                    {{ message }}
                  </div>
                  <div
                    v-if="succshow"
                    class="notification"
                    style="
                      margin-bottom: 10px;
                      background: green;
                      padding: 20px;
                    "
                  >
                    {{ message }}
                  </div>
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="table-responsive prductTbl">
                        <table class="table table-cart">
                          <thead>
                            <tr>
                              <th
                                v-if="
                                  plan === 'Platinum-Membership' ||
                                  plan === 'Gold-Membership' ||
                                  plan === 'Trial-Membership'
                                "
                                width="20"
                                class="text-center"
                              >
                                &nbsp;
                              </th>
                              <th
                                v-if="
                                  plan === 'Platinum-Membership' ||
                                  plan === 'Gold-Membership' ||
                                  plan === 'Trial-Membership'
                                "
                                width="20"
                                class="text-center"
                              >
                                &nbsp;
                              </th>
                              <th
                                v-if="
                                  plan === 'Platinum-Membership' ||
                                  plan === 'Gold-Membership' ||
                                  plan === 'Trial-Membership'
                                "
                                width="20"
                                class="text-center"
                              >
                                &nbsp;
                              </th>
                              <th
                                v-if="
                                  plan === 'Platinum-Membership' ||
                                  plan === 'Gold-Membership' ||
                                  plan === 'Trial-Membership'
                                "
                                width="20"
                                class="text-center"
                              >
                                &nbsp;
                              </th>
                              <th
                                v-if="
                                  plan === 'Platinum-Membership' ||
                                  plan === 'Gold-Membership' ||
                                  plan === 'Trial-Membership'
                                "
                                width="50"
                                class="text-center"
                              >
                                Total Fee
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="plan === 'Platinum-Membership'">
                              <td style="width: 270px">
                                <b
                                  >20% discount when membership fee is paid in
                                  full.</b
                                >
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">$800.00</td>
                            </tr>
                            <tr v-if="plan === 'Gold-Membership'">
                              <td style="width: 270px">
                                <b>Membership Fee is paid in four payments.</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">$1,000.00</td>
                            </tr>
                            <tr v-if="plan === 'Trial-Membership'">
                              <td style="width: 270px">
                                <b
                                  >Membership Fee has a payment of $95.00 for 1
                                  month only.</b
                                >
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">&nbsp;</td>
                              <td class="text-center">$95.00</td>
                            </tr>
                          </tbody>
                        </table>

                        <table class="table table-cart">
                          <thead>
                            <tr>
                              <th>Products</th>
                              <th>&nbsp;</th>
                              <th width="100" class="text-center">&nbsp;</th>
                              <th width="50" class="text-center">&nbsp;</th>
                              <th width="100" class="text-center">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="plan === 'Platinum-Membership'">
                              <td colspan="2">
                                <b>Single Membership Fee Payment</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  >$800.00</span
                                >
                              </td>
                            </tr>
                            <tr v-if="plan === 'Gold-Membership'">
                              <td colspan="2">
                                <b>First Membership Fee Payment</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  >$250.00</span
                                >
                              </td>
                            </tr>
                            <tr v-if="plan === 'Trial-Membership'">
                              <td colspan="2">
                                <b>Single Membership Fee Payment</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  >$95.00</span
                                >
                              </td>
                            </tr>
                            <tr v-if="plan === 'Platinum-Membership'">
                              <td colspan="2">
                                <b>Monthly Dues</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  ><b>$195.00</b></span
                                >
                              </td>
                            </tr>

                            <tr v-if="plan === 'Gold-Membership'">
                              <td colspan="2">
                                <b>Monthly Dues</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  ><b>$195.00</b></span
                                >
                              </td>
                            </tr>
                            <tr v-if="plan === 'Student-Membership'">
                              <td colspan="2">
                                <b>Monthly Dues</b>
                              </td>
                              <td class="text-center">&nbsp;</td>
                              <td width="50" class="text-center">&nbsp;</td>
                              <td class="text-center">
                                <span class="priceBold" id="total2"
                                  ><b>$49.00</b></span
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="panel panel-primary">
                        <div class="panel-heading">
                          <b style="font-size: 17px">Order Summary</b>
                        </div>
                        <div class="panel-body">
                          <div
                            class="row ordrtotal"
                            v-if="plan === 'Platinum-Membership'"
                          >
                            <div class="col"><b>Total Due</b></div>
                            <div class="col text-right">
                              <b><span id="total4">$995.00</span></b>
                            </div>
                          </div>
                          <div
                            class="row ordrtotal"
                            v-if="plan === 'Gold-Membership'"
                          >
                            <div class="col"><b>Total Due</b></div>
                            <div class="col text-right">
                              <b><span id="total4">$445.00</span></b>
                            </div>
                          </div>
                          <div
                            class="row ordrtotal"
                            v-if="plan === 'Trial-Membership'"
                          >
                            <div class="col"><b>Total Due</b></div>
                            <div class="col text-right">
                              <b><span id="total4">$95.00</span></b>
                            </div>
                          </div>
                          <div
                            class="row ordrtotal"
                            v-if="plan === 'Student-Membership'"
                          >
                            <div class="col"><b>Total Due</b></div>
                            <div class="col text-right">
                              <b><span id="total4">$49.00</span></b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="panel panel-primary billingTab">
                        <div class="panel-heading">
                          <b>Billing Information</b>
                        </div>
                        <div class="panel-body form-horizontal">
                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>First Name</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.firstName"
                                placeholder="First Name"
                                id="x_first_name"
                                name="x_first_name"
                                value=""
                                size="10"
                                type="text"
                                required=""
                              />
                              <div
                                data-lastpass-icon-root="true"
                                style="
                                  position: relative !important;
                                  height: 0px !important;
                                  width: 0px !important;
                                  float: left !important;
                                "
                              ></div>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Last Name</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.lastName"
                                placeholder="Last Name"
                                id="x_last_name"
                                name="x_last_name"
                                required=""
                                value=""
                                size="12"
                                type="text"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Email Address</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.email"
                                placeholder="Email Address"
                                required=""
                                id="x_email"
                                name="x_email"
                                value=""
                                size="15"
                                type="email"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Practice Name</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                placeholder="Practice Name"
                                v-model="userData.practiceName"
                                id="company"
                                name="company"
                                required=""
                                size="25"
                                type="text"
                                value=""
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Address - Line 1</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.address1"
                                placeholder="Address - Line 1"
                                required=""
                                id="x_address"
                                value=""
                                name="x_address"
                                size="25"
                                type="text"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              >Address - Line 2</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.address2"
                                placeholder="Address - Line 2"
                                id="addressLine2"
                                name="addressLine2"
                                value=""
                                size="25"
                                type="text"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>City</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.city"
                                placeholder="City"
                                required=""
                                id="x_city"
                                name="x_city"
                                value=""
                                size="15"
                                type="text"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>State</label
                            >
                            <div class="col-md-8">
                              <select
                                class="form-control"
                                v-model="userData.stateID"
                                id="x_state"
                                name="x_state"
                                required=""
                              >
                                <option value="0">Select state</option>

                                <option value="1">Alabama</option>

                                <option value="2">Alaska</option>

                                <option value="3">Arizona</option>

                                <option value="4">Arkansas</option>

                                <option value="5">California</option>

                                <option value="6">Colorado</option>

                                <option value="7">Connecticut</option>

                                <option value="8">Delaware</option>

                                <option value="9">Florida</option>

                                <option value="10">Georgia</option>

                                <option value="11">Hawaii</option>

                                <option value="12">Idaho</option>

                                <option value="13">Illinois</option>

                                <option value="14">Indiana</option>

                                <option value="15">Iowa</option>

                                <option value="16">Kansas</option>

                                <option value="17">Kentucky</option>

                                <option value="18">Louisiana</option>

                                <option value="19">Maine</option>

                                <option value="20">Maryland</option>

                                <option value="21">Massachusetts</option>

                                <option value="22">Michigan</option>

                                <option value="23">Minnesota</option>

                                <option value="24">Mississippi</option>

                                <option value="25">Missouri</option>

                                <option value="26">Montana</option>

                                <option value="27">Nebraska</option>

                                <option value="28">Nevada</option>

                                <option value="29">New Hampshire</option>

                                <option value="30">New Jersey</option>

                                <option value="31">New Mexico</option>

                                <option value="32">New York</option>

                                <option value="33">North Carolina</option>

                                <option value="34">North Dakota</option>

                                <option value="35">Ohio</option>

                                <option value="36">Oklahoma</option>

                                <option value="37">Oregon</option>

                                <option value="38">Pennsylvania</option>

                                <option value="39">Rhode Island</option>

                                <option value="40">South Carolina</option>

                                <option value="41">South Dakota</option>

                                <option value="42">Tennessee</option>

                                <option value="43">Texas</option>

                                <option value="44">Utah</option>

                                <option value="45">Vermont</option>

                                <option value="46">Virginia</option>

                                <option value="47">Washington</option>

                                <option value="48">West Virginia</option>

                                <option value="49">Wisconsin</option>

                                <option value="50">Wyoming</option>

                                <option value="51">Washington DC</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Zip Code</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.zip"
                                placeholder="Zip Code"
                                required=""
                                id="x_zip"
                                name="x_zip"
                                size="5"
                                value=""
                                type="text"
                              />
                            </div>
                          </div>

                          <div class="form-group row">
                            <label class="col-md-4 control-label"
                              ><sup>*</sup>Phone Number</label
                            >
                            <div class="col-md-8">
                              <input
                                class="form-control"
                                v-model="userData.phone"
                                placeholder="Phone Number"
                                required=""
                                id="x_phone"
                                name="x_phone"
                                value=""
                                size="25"
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <input
                  type="hidden"
                  name="x_amount"
                  v-model="userData.amount"
                  value="445"
                />
                <input
                  type="hidden"
                  name="x_monthly_amount"
                  v-model="userData.monthlyAmount"
                  value="250.00"
                />
                <input
                  type="hidden"
                  name="x_exp_date"
                  v-model="userData.expDate"
                  id="x_exp_date"
                  value="12023"
                />

                <div class="row">
                  <div class="col-md-12 pymentsec">
                    <input
                      id="shippingRequired"
                      name="shippingRequired"
                      type="hidden"
                      value="false"
                    />
                    <div class="panel panel-primary">
                      <div class="panel-heading">
                        <b>Payment</b>
                        <div class="cardicn pull-right">
                          <img src="images/card-icon.png" alt="" /> &nbsp;<span
                            style="font-size: 17px"
                            >Credit Card</span
                          >
                        </div>
                      </div>
                      <input
                        id="creditCardType"
                        name="paymentType"
                        type="hidden"
                        value="creditcard"
                      />
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Credit Card Number *</label>

                              <input
                                class="regula-validation checkout form-control"
                                v-model="userData.cardNumber"
                                id="x_card_num"
                                name="x_card_num"
                                required=""
                                type="text"
                                maxlength="16"
                                autocomplete="off"
                              />
                              <div
                                data-lastpass-icon-root="true"
                                style="
                                  position: relative !important;
                                  height: 0px !important;
                                  width: 0px !important;
                                  float: left !important;
                                "
                              ></div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Expiration Date</label>
                              <div class="expiration-date">
                                <select
                                  v-model="userData.cardMonth"
                                  class="checkoutShortest form-control"
                                  id="expirationMonth"
                                  name="expirationMonth"
                                  size="1"
                                  data-on="Component.Select"
                                >
                                  <option value="01">1</option>

                                  <option value="02">2</option>

                                  <option value="03">3</option>

                                  <option value="04">4</option>

                                  <option value="05">5</option>

                                  <option value="06">6</option>

                                  <option value="07">7</option>

                                  <option value="08">8</option>

                                  <option value="09">9</option>

                                  <option value="10">10</option>

                                  <option value="11">11</option>

                                  <option value="12">12</option>
                                </select>

                                <select
                                  v-model="userData.cardYear"
                                  class="checkoutShortest form-control"
                                  id="expirationYear"
                                  name="expirationYear"
                                  size="1"
                                  data-on="Component.Select"
                                >
                                  <option>2023</option>

                                  <option>2024</option>

                                  <option>2025</option>

                                  <option>2026</option>

                                  <option>2027</option>

                                  <option>2028</option>

                                  <option>2029</option>

                                  <option>2030</option>

                                  <option>2031</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <div class="form-group">
                              <label>CVV Code (optional)</label>
                              <input
                                class="form-control"
                                v-model="userData.cvv"
                                id="x_cvv_code"
                                value=""
                                name="x_card_code"
                                type="text"
                                maxlength="4"
                                autocomplete="off"
                              />
                            </div>
                          </div>

                          <div class="col-md-2">
                            <button
                              type="submit"
                              class="btn btn-warning pull-right"
                              name="placeOrderAuthorize"
                              id="placeOrderAuthorize"
                            >
                              Place Order
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- end page-header -->
    </div>
    <Footer />
  </section>
</template>

<script>
import userAPI from "../userApi";
import Footer from "./../layout/footer.vue";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  requiredIf,
  sameAs,
  integer,
} from "vuelidate/lib/validators";

export default {
  name: "contact_us",
  props: {
    plan: String, // Define plan prop type
  },
  mixins: [validationMixin],
  components: { Footer },
  data() {
    return {
      userData: {
        upgrade: "",
        firstName: "",
        plan: this.plan,
        lastName: "",
        phone: "",
        email: "",
        practiceName: "",
        address1: "",
        address2: "",
        city: "",
        stateID: "",
        zip: "",
        amount: "",
        monthlyAmount: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
      },
      response: "",
      message: "",
      errShow: false,
      succshow: false,
    };
  },
  validations: {
    userData: {
      firstName: {
        required,
      },
      email: {
        required,
        email,
      },
      lastName: {
        required,
      },
      phone: {
        required,
      },
      practiceName: {
        required,
      },
      address1: {
        required,
      },
      city: {
        required,
      },
      zip: {
        required,
      },
      amount: {
        required,
      },
      monthlyAmount: {
        required,
      },
      cardMonth: {
        required,
      },
      cardYear: {
        required,
      },
      cardNumber: {
        required,
      },
    },
  },
  mounted() {
    this.updateUserData(this.plan);
  },
  watch: {
    plan(newPlan) {
      this.updateUserData(newPlan);
    },
  },
  methods: {
    updateUserData(plan) {
      switch (plan) {
        case "Platinum-Membership":
          this.userData.amount = 995;
          this.userData.monthlyAmount = 195;
          break;
        case "Gold-Membership":
          this.userData.amount = 445;
          this.userData.monthlyAmount = 195;
          break;
        case "Trial-Membership":
          this.userData.amount = 95;
          this.userData.monthlyAmount = 95;
          break;
        case "Student-Membership":
          this.userData.amount = 49;
          this.userData.monthlyAmount = 49;
          break;
        default:
          this.userData.amount = 1000;
          this.userData.monthlyAmount = 195;
          break;
      }
    },

    createAccount() {
      // this.errShow = false;
      this.$v.userData.$touch();
      if (this.$v.userData.$anyError) {
        return;
      }
      userAPI.createAccount(
        this.userData,
        (res) => {
          if (res.data.success === 1) {
            this.succshow = true;
            this.message = res.data.message;
            setTimeout(() => {
              this.succshow = false;
            }, 10000);
          } else {
            this.errShow = true;
            this.message = res.data.message;
            this.$showNotification({ message: this.message }, "success");
            setTimeout(() => {
              this.errShow = false;
            }, 10000);
          }
        },
        (err) => {
          this.message = err.response.data.message;
          this.$showNotification({ message: this.message }, "error");
        }
      );
    },
  },
};
</script>

<style>
.full-header {
  width: 100%;
  background: url("./../../assets/images/shutterstock_217119211.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.full-header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(20, 55, 120, 0.7);
}

.topNavigation {
  background: -webkit-linear-gradient(to top, #dbeefe, #ffffff);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(to top, #dbeefe, #ffffff);
  /* For Opera 11.1 to 12.0 */
  /* For Firefox 3.6 to 15 */
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#dbeefe),
    to(#ffffff)
  );
  background: -webkit-linear-gradient(bottom, #dbeefe, #ffffff);
  background: -o-linear-gradient(bottom, #dbeefe, #ffffff);
  background: linear-gradient(to top, #dbeefe, #ffffff);
  border: none;
  border-radius: 0;
  min-height: 56px;
  margin: 0;
}

.topNavigation .navbar-nav > li > a {
  text-transform: uppercase;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 17px;
  color: #1b4463;
  position: relative;
  font-weight: bold;
  height: 60px;
  display: flex;
  align-items: center;
}

.topNavigation .navbar-nav > li:before {
  content: "";
  position: absolute;
  right: 0;
  height: 25px;
  width: 1px;
  top: 15px;
  background: #cfe8fc;
}

.topNavigation .navbar-nav > li:last-child:before {
  display: none;
}

.topNavigation .navbar-nav > li > a:hover,
.topNavigation .navbar-nav > li.active a {
  color: #ffffff;
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(rgb(238, 167, 34)),
    to(rgb(229, 199, 81))
  );
  background: -webkit-linear-gradient(
    bottom,
    rgb(238, 167, 34) 0%,
    rgb(229, 199, 81) 100%
  );
  background: -o-linear-gradient(
    bottom,
    rgb(238, 167, 34) 0%,
    rgb(229, 199, 81) 100%
  );
  background: linear-gradient(
    to top,
    rgb(238, 167, 34) 0%,
    rgb(229, 199, 81) 100%
  );
}

.topNavigation .navbar-nav > li {
  position: relative;
  text-align: center;
}

.topNavigation .navbar-nav > li:after {
  content: "";
  position: absolute;
  right: 0;
  top: 16px;
  height: 25px;
  background: #cfe8fc;
  width: 1px;
}

.topNavigation .navbar-nav > li:last-child:after {
  display: none;
}

.topNavigation .navbar-toggle {
  background-color: rgb(67, 119, 192);
  border: 1px solid rgb(67, 119, 192);
}

.topNavigation .navbar-toggle .icon-bar {
  background: #ffffff;
}

.logoWrap {
  position: relative;
}

.logoWrap img {
  position: absolute;
  top: -22px;
  left: 181px;
}

.header-content {
  padding: 115px 0;
}

.header-content.inner {
  padding: 20px 0 0;
}

.top-header {
  padding: 15px 0;
  border-top: 4px solid #001e4b;
  position: relative;
}

.topMessage {
  color: #fff;
  text-align: center;
  border-radius: 50px;
  -webkit-box-shadow: 0 3px 8px rgba(255, 255, 255, 0.1);
  box-shadow: 0 3px 8px rgba(255, 255, 255, 0.1);
  padding: 5px;
  font-size: 22px;
  text-shadow: 0 0 9px;
}

.topMessage p {
  margin: 0;
}

/* content area*/
.contentArea {
  padding-top: 30px;
  margin-bottom: 20px;
}

.contentWrap {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 5px;
  overflow: hidden;
}

.contentbox {
  padding: 15px;
  border-bottom: 1px solid #ececec;
  margin-bottom: 15px;
}

.frgot-link a {
  color: #474747;
}

.frgot-link a:hover {
  text-decoration: none;
}

.frgot-link a i {
  color: #b4d3ed;
  display: inline-block;
  width: 15px;
  height: 15px;
  background: #b4d3ed;
  border-radius: 50%;
  text-align: center;
  box-sizing: border-box;
  font-size: 12px;
  color: #fff;
  padding-right: 2px;
}

.contentbox:last-child {
  border: none;
}

.frgot-link {
  margin: 0;
}

.box-header .heading {
  font-size: 33px;
  color: #e89400;
  margin-top: 0;
  font-weight: bold;
}

.register-container .box-header h3 {
  font-size: 33px;
  color: #e89400;
  margin-top: 0;
  font-weight: bold;
}

.register-container header.full-header .box-header .heading {
  position: relative;
  color: #ffde52;
  font-size: 40px;
}

.box-header h4 {
  margin-bottom: 0;
  color: #454545;
  font-size: 20px;
}

/* media quries*/
@media (min-width: 1200px) {
  .container {
    width: 1130px;
    padding: 0;
  }
}

@media (max-width: 991px) {
  .topNavigation .navbar-nav > li > a {
    font-size: 14px;
  }

  .topMessage {
    margin-bottom: 20px;
    font-size: 19px;
  }

  .header-content {
    padding: 60px 0;
  }

  a.navbar-brand.logoWrap img {
    height: 150px;
    width: 150px;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 10px 0;
  }

  .box-header .heading {
    font-size: 30px;
  }
}

@media (max-width: 480px) {
  .topMessage {
    padding: 0;
    font-size: 15px;
    background: transparent;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin-bottom: 0;
    padding-top: 3px;
    white-space: nowrap;
  }

  a.navbar-brand.logoWrap img {
    height: auto;
    width: 100px;
    top: -20px;
  }

  .box-header .heading {
    font-size: 24px;
  }
}
</style>